import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Eyebrow } from './ui/Eyebrow';
import { comparison } from '../data/content';
export function BeforeAfterSection() {
  return <section className="border-b border-line bg-cream" data-id="element-1" data-mp="pnin3tuode80">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-2" data-mp="ppdcplgw5uif">
        <div className="max-w-2xl" data-id="element-3" data-mp="kwtvmeizwh8v">
          <Eyebrow data-id="element-4" data-mp="kvr6oc58govl">Antes vs. después</Eyebrow>
          <h2 className="mt-4 font-condensed text-4xl uppercase leading-[0.95] tracking-tight text-ink sm:text-5xl" data-id="element-5" data-mp="zlq2w9d89q8f">
            Dejá de improvisar. Empezá a enseñar con un sistema.
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-6" data-mp="18mefczmz3ij7">
            La misma clase, con y sin el pack de El Profe de Guitarra.
          </p>
        </div>

        <div className="mt-12 overflow-hidden rounded-2xl border border-line bg-paper" data-id="element-7" data-mp="13lh313on9ipm">
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-8" data-mp="3ae9lz0udgwuk">
            <p className="border-b border-line px-6 py-4 text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute sm:border-r" data-id="element-9" data-mp="35fzt4ww4e8c4">
              Sin El Profe de Guitarra
            </p>
            <p className="hidden border-b border-line bg-accent-soft px-6 py-4 text-[11px] font-semibold uppercase tracking-eyebrow text-accent-dark sm:block" data-id="element-10" data-mp="3bmthvvm9c750">
              Con El Profe de Guitarra
            </p>
          </div>

          <ul data-id="element-11" data-mp="3lez5yu9e24ex">
            {comparison.map(row => <li key={row.without} className="grid grid-cols-1 border-b border-line last:border-b-0 sm:grid-cols-2" data-id="element-12" data-mp="3pf19l8yop7wu">
                <div className="flex items-start gap-3 px-6 py-5 sm:border-r sm:border-line" data-id="element-13" data-mp="3udkvj9da2jp7">
                  <XIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-ink-mute" data-id="element-14" data-mp="379rr5gvv4u6" />
                  <span className="text-[15px] leading-relaxed text-ink-mute line-through decoration-ink-mute/40" data-id="element-15" data-mp="86mg5unekjyv">
                    {row.without}
                  </span>
                </div>
                <div className="flex items-start gap-3 bg-accent-soft/50 px-6 py-5" data-id="element-16" data-mp="29xzeu1ys1vmh">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-accent" data-id="element-17" data-mp="21xl3lsb3x6yp" />
                  <span className="text-[15px] font-medium leading-relaxed text-ink" data-id="element-18" data-mp="1wyhwm2bkgqo3">
                    {row.with}
                  </span>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}